export default "/images/transfering-codes-active-dark.svg?a68493559b1dff1c575c7fcff99639be";